import { ReactElement } from 'react'
import { Delete, LinkOff } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Stack, Typography } from '@mui/material'
import { FileUsageDTO } from '@api/fastAPI.schemas'

interface Props {
  usage: FileUsageDTO
  disabled: boolean
  isRemoving: boolean
  isUnlinking: boolean
  onRemove: () => void
  onUnlink: () => void
}

/** Document item showing the file, removed or unlinked to free the file */
const FileUsageRow = ({
  usage,
  disabled,
  isRemoving,
  isUnlinking,
  onRemove,
  onUnlink,
}: Props): ReactElement => (
  <Stack
    direction="row"
    alignItems="center"
    spacing={1}
    sx={{ py: 1, borderBottom: '1px solid', borderColor: 'divider' }}
    data-cy="file-usage-row"
  >
    <Stack sx={{ flex: 1, minWidth: 0 }}>
      <Typography variant="body2" noWrap title={usage.name}>
        {usage.name}
      </Typography>
      {usage.descendant_count > 0 && (
        <Typography variant="caption" color="text.secondary" data-cy="file-usage-descendants">
          {usage.descendant_count === 1
            ? 'inkl. 1 untergeordneter Eintrag'
            : `inkl. ${usage.descendant_count} untergeordneter Einträge`}
        </Typography>
      )}
    </Stack>
    <LoadingButton
      size="small"
      variant="contained"
      startIcon={<LinkOff />}
      loadingPosition="start"
      onClick={onUnlink}
      loading={isUnlinking}
      disabled={disabled}
      data-cy="btn-file-usage-unlink"
    >
      Verknüpfung lösen
    </LoadingButton>
    <LoadingButton
      size="small"
      variant="contained"
      color="error"
      startIcon={<Delete />}
      loadingPosition="start"
      onClick={onRemove}
      loading={isRemoving}
      disabled={disabled}
      data-cy="btn-file-usage-remove"
    >
      Entfernen
    </LoadingButton>
  </Stack>
)

export default FileUsageRow
